import globalAxios from "./global-axios";

export default {
    getHeaderLinks(){
        return globalAxios.get(`menu_items`)
    },
    getSingleHeaderLinkData(payload){
        return globalAxios.get(`page_items/${payload}`)
    },
}